export default "__VITE_ASSET__CKsTTQvX__"